// extracted by mini-css-extract-plugin
module.exports = {"pagination":"Pagination-module__pagination___2zJCt","info":"Pagination-module__info___2kwWN","buttons":"Pagination-module__buttons___18LBK"};